module.exports = __webpack_public_path__ + "static/media/fg.a3c79420.png";